export default __webpack_public_path__ + "b611ef7c80a34c4f1e7237d88137ba7a.svg";